import { createRouter, createWebHashHistory } from 'vue-router'
import MapView from '../views/MapView.vue'
import QuestView from '../views/QuestView.vue'
import ResourceView from '../views/ResourceView.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', redirect: '/map' },
    { path: '/map', name: 'map', component: MapView },
    { path: '/quests', name: 'quests', component: QuestView },
    { path: '/resources', name: 'resources', component: ResourceView },
    { path: '/:pathMatch(.*)*', redirect: '/map' }
  ]
})

export default router
